module.exports = (mappedRoutes) => (Odigeo.Router.handlers.dpredirect = function(currentPage, params) {
    $(() => Odigeo.Router.navigate(Odigeo._.get(mappedRoutes, `${currentPage}.to`), {
        params: params.concat(Odigeo._.get(mappedRoutes, `${currentPage}.params`, '')),
        trigger: true,
        replace: true,
    }));
});
